import getStat from "./getStat";
import getActivity from "./getActivity";

export default {
  getStat,
  getActivity,
};
